// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module--root--1C_ku","left":"style-module--left--2REY0","right":"style-module--right--2rB4m"};